import { api } from "@/services/api"

export const resendInvite = async (userId: string) => {
  await api.post(`/users/${userId}/resend_invite/`)
}
